import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuscarClienteComponent } from './components/cliente/buscar-cliente/buscar-cliente.component';
import { LoginComponent } from './auth/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { CrearClienteComponent } from './components/cliente/crear-cliente/crear-cliente.component';
import { EditarClienteComponent } from './components/cliente/editar-cliente/editar-cliente.component';
import { ListarDeudasComponent } from './components/deudas/listar-deudas/listar-deudas.component';
import { CrearDeudaComponent } from './components/deudas/crear-deuda/crear-deuda.component';
import { ListaProductosComponent } from './components/producto/lista-productos/lista-productos.component';
import { CrearProductoComponent } from './components/producto/crear-producto/crear-producto.component';
import { EditarProductoComponent } from './components/producto/editar-producto/editar-producto.component';
import { RegistroComponent } from './auth/registro/registro.component';
import { RecuperarPasswordComponent } from './auth/recuperar-password/recuperar-password.component';
import { CambiarPasswordForzadoComponent } from './auth/cambiar-password-forzado/cambiar-password-forzado.component';
import { CambiarPasswordComponent } from './auth/cambiar-password/cambiar-password.component';
import { ListaPagosComponent } from './components/pagos/lista-pagos/lista-pagos.component';
import { CrearPagoComponent } from './components/pagos/crear-pago/crear-pago.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'cliente', component: BuscarClienteComponent,canActivate: [AuthGuard] },
  { path: 'cliente/nuevo', component: CrearClienteComponent,canActivate: [AuthGuard] },
  { path: 'cliente/editar/:id', component: EditarClienteComponent, canActivate: [AuthGuard] },
  { path: 'cliente/libreta/:id', component: ListarDeudasComponent,canActivate: [AuthGuard] },
  { path: 'cliente/:id/nueva-deuda', component: CrearDeudaComponent, canActivate: [AuthGuard] },
  { path: 'productos', component: ListaProductosComponent, canActivate: [AuthGuard] },
  { path: 'productos/nuevo', component: CrearProductoComponent, canActivate: [AuthGuard] },
  { path: 'productos/editar/:id', component: EditarProductoComponent, canActivate: [AuthGuard] },
  { path: 'registro', component: RegistroComponent },
  { path: 'recuperar-password', component: RecuperarPasswordComponent},
  { path: 'cambiar-password', component: CambiarPasswordComponent, canActivate: [AuthGuard] },
  { path: 'cambiar-password-forzado', component: CambiarPasswordForzadoComponent },
  { path: 'lista-pagos', component: ListaPagosComponent, canActivate: [AuthGuard] },
  { path: 'crear-pago', component: CrearPagoComponent, canActivate: [AuthGuard] }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
